import React from 'react';

function Comissoes() {
  return <div>Comissoes</div>;
}

export default Comissoes;
